import { useState, useMemo, useCallback, useEffect, useContext } from "react";
import {
    Box,
    Stack,
    Typography,
    Card,
    Grid,
    CardContent,
} from "@mui/material";
import { useGridApiRef, getGridStringOperators } from "@mui/x-data-grid";
import Chart from "../../components/Chart"
import NodataImg from "../../assets/images/noData.png";
import { useDispatch, useSelector } from "react-redux";
import { AppErrorsApi } from "../../store/analytics/AppErrorsTable";
import { ThemeContext } from '../../context/ThemeContext';
import dayjs from "dayjs";
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";
import DataGridComponent from "../../components/DataGridComponent";
import { AiOutlineBell } from 'react-icons/ai'
import { useNavigate } from "react-router-dom";
import { AppErrors as AppErrorsExport } from "../../store/apiConfigs";


const appErrorsColumns = [
    {
        field: "event_timestamp",
        headerName: "Date",
        width: 260,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        renderCell: (data) => (<>
            <Typography sx={{ overflowWrap: "anywhere" }}>{data?.row?.event_timestamp && dayjs(data?.row?.event_timestamp).format("YYYY-MM-DD")}</Typography>
        </>)
    },
    {
        field: "platform",
        headerName: "Platform",
        width: 180,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
    },
    {
        field: "event_id",
        headerName: "Event ID",
        width: 260,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (op) => op.value === "equals" || op.value === "contains"
        ),
        sortable: false,
    },
    {
        field: "issue_title",
        headerName: "Issue Title",
        width: 300,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (op) => op.value === "equals" || op.value === "contains"
        ),
        sortable: false,
    },
    {
        field: "issue_subtitle",
        headerName: "Issue Sub title (description)",
        width: 350,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (op) => op.value === "equals" || op.value === "contains"
        ),
        sortable: false,
    },
    {
        field: "exception_title",
        headerName: "Exception (Title)",
        width: 300,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (op) => op.value === "equals" || op.value === "contains"
        ),
        sortable: false,
    },
    {
        field: "exception_subtitle",
        headerName: "Exception (sub Title)",
        width: 350,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (op) => op.value === "equals" || op.value === "contains"
        ),
        sortable: false,
    },

];



export default function AppErrors({ region, state, loading, type, module, monthDaily, startDate, endDate, isMaskingEnabled, schoolType }) {
    const [activevsavgtimespent, setActiveVsAvgTimeSpent] = useState({ l1: true, l2: true });
    const [teacherRegister, setTeacherRegistration] = useState({ l1: true, l2: true, l3: true, l4: true });
    const apiRef = useGridApiRef();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [isDownload, setIsDownload] = useState(false)
    const AppErrorsTable = useSelector((state) => state?.AppErrorsTable);
    const { result: tableResult, loading: tableLoading, total } = AppErrorsTable;
    const [queryOptions, setQueryOptions] = useState({});
    const { paginationModel, setPaginationModel } = useContext(ThemeContext)

    const onFilterChange = useCallback((filterModel) => {
        setQueryOptions({ filterModel: { ...filterModel } });
    }, []);
    const toggleTeacherRegistration = useCallback((key) => {
        setTeacherRegistration(prevState => ({ ...prevState, [key]: !prevState[key] }));
    }, []);
    const toggleActiveVsAvgTimeSpent = useCallback((key) => {
        setActiveVsAvgTimeSpent(prevState => ({ ...prevState, [key]: !prevState[key] }));
    }, []);
    const getRowSpacing = useCallback((params) => {
        return {
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
        };
    }, []);
    const handleSortModelChange = useCallback((sortModel) => {
        setQueryOptions({ sortModel: [...sortModel] });
    }, []);

    useEffect(() => {
        // console.log("isMaskingEnabled",isMaskingEnabled);
        const filterModel = queryOptions?.filterModel;
        const items = filterModel?.items;
        const firstItem = items && items.length > 0 ? items[0] : {};
        const quickFilterValues = filterModel?.quickFilterValues;
        const sortModel = queryOptions?.sortModel;
        let query
        if (sortModel?.length > 0) {
            query = {
                module_type: module,
                school_type: schoolType,
                page: paginationModel?.page + 1,
                page_size: paginationModel?.pageSize,
                sort_order: sortModel[0].sort || "desc",
                field: firstItem.field || '',
                operator: firstItem.operator || (quickFilterValues && "contains") || '',
                value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
            };
        } else {
            query = {
                module_type: module,
                school_type: schoolType,
                page: paginationModel?.page + 1,
                page_size: paginationModel?.pageSize,
                field: firstItem.field || '',
                city: region,
                sort_order: "desc",
                state: state,
                start_date: startDate,
                end_date: endDate,
                operator: firstItem.operator || (quickFilterValues && "contains") || '',
                value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
            };
        }
        dispatch(AppErrorsApi(query));
    }, [dispatch, queryOptions, paginationModel, region, state, module, startDate, endDate, isMaskingEnabled, schoolType]);


    return (
        <>
            <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center" justifyContent={"space-between"}>
                <Typography variant="h3">App Errors</Typography>
            </Stack>
            <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center">
                <DataGridComponent
                    disableColumnMenu
                    disableColumnSorting
                    loading={tableLoading}
                    rowCount={total}
                    pageSize={paginationModel?.pageSize}
                    onPageSizeChange={(newPageSize) => {
                        setPaginationModel({
                            ...paginationModel,
                            pageSize: newPageSize,
                        })
                    }}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    sx={{
                        height: 500
                    }}
                    rows={tableResult || []}
                    getRowId={(r) => {
                        return r.event_id
                    }}
                    getRowSpacing={getRowSpacing}
                    columns={appErrorsColumns}
                    onSortModelChange={handleSortModelChange}
                    onFilterModelChange={onFilterChange}
                    slots={{
                        noRowsOverlay: () => (
                            <Box className="noData">
                                <img src={NodataImg} alt="no data found" />
                            </Box>
                        ),
                        toolbar: (props) =>
                        (CustomGridToolbar({
                            ...props, moduleType: "CourseProgress",
                            queryOptions,
                            paginationModel,
                            isDownload,
                            setIsDownload,
                            apiUrl: AppErrorsExport,
                            hasfilter: false,
                            hasSearch: false,
                            region,
                            state,
                            startDate,
                            endDate
                        })),
                    }}
                    slotProps={{
                        loadingOverlay: {
                            variant: 'linear-progress',
                            noRowsVariant: 'linear-progress',
                        },
                        toolbar: {
                            // showQuickFilter: true,
                            showQuickFilter: false,
                        },
                    }}
                />
            </Stack>
            <BackdropUI open={isDownload} />
        </>)
}

